import { t } from "i18next";
import * as yup from "yup";

export const changePasswordValidationSchema = () =>
  yup.object().shape({
    currentPassword: yup
      .string()
      .min(8, " ")
      .max(20, " ")
      .required(t("form.error.password.required")!),
    newPassword: yup
      .string()
      .min(8, " ")
      .max(20, " ")
      .required(t("form.error.newpassword.required")!),
    confirmNewPassword: yup
      .string()
      .oneOf(
        [yup.ref("newPassword"), ""],
        t("form.error.confirmNewPassword.matching")!
      )
      .required(t("form.error.confirmPassword.required")!),
  });
